/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { VerticaisManager, paths } from "src/components/vendas/VerticaisManager";
import api, { IDataRequest, STATUS_CODE, apiNoLoading } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";
import { Atributo } from "src/providers/cadastros/AtributosProvider";
import { atributos$, estadosServico$, getChacheTime, getEstados, getEstadosServico, getRegioes, regioes$, verificarSegmentoConta } from "src/store/global.store";
import { componentes$, estados$, getComponentes, getGruposEstrutura, grupoEstrutura$, CacheType } from "src/store/global.store";
import { formState$ } from "src/store/vendas/projetos/store";
import { ComponenteProjetoComQuantidade, ProjetoOutput } from "../../types";
import { Estado } from "src/types";
import { Projeto, GrupoEstrutura, ProjetoTipoType } from "src/components/projetos/types";
import { ProjetoHelper } from "../../projetoHelper";
import { DEFAULT_PROJETO } from "src/components/projetos/constants";
import { ModalInfoInativos } from "../components/ModalItensInativos";
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA, MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import { notifierStore } from "src/framework/store/NotifierStore";
import { Componente, ID_MEDIDOR, ID_MONITORAMENTO, ID_RSD, ID_TRANSFORMADOR_CORRENTE } from "src/components/componentes/types";
import moment from "moment";
import adminStore from "src/store/AdminStore";

const verticaisManager = new VerticaisManager(paths, api, apiNoLoading)
const componenteProvider = new ComponenteProvider()

export const getAtributos = async (): Promise<any[]> => {
  const now = moment().format("x")
  const { expires, loading } = atributos$.getValue();
  if (expires < Number(now) && !loading) {
      atributos$.next({ ...atributos$.getValue(), loading: true })
      const attrs = await adminStore.getAtributos(true)
      const newExpireDate = getChacheTime()
      atributos$.next({
          data: attrs,
          expires: newExpireDate,
          loading: false
      })
      return attrs;
  }

  return atributos$.getValue().data;
}

const init = async () => {
  await Promise.all([
    getAtributos(),
    getComponentes(),
    getGruposEstrutura(),
    getEstados(),
    getRegioes(),
    getEstadosServico({ force: true }),
  ])
}

export function EdicaoLayout({ children, clonarProjeto }: { children: React.ReactNode; clonarProjeto?: boolean }){
  const { id } = useParams<{id: string}>()
  const history = useHistory();

  const formState = useObservable<Projeto>(formState$)
  const estados = useObservable<CacheType<Estado[]>>(estados$)
  const grupoEstrutura = useObservable<CacheType<GrupoEstrutura[]>>(grupoEstrutura$)
  const cachedComponentes = useObservable<CacheType<Componente[]>>(componentes$)
  const cachedAtributos = useObservable<CacheType<Atributo[]>>(atributos$)
  const regioes = useObservable(regioes$)
  const estadosServico = useObservable(estadosServico$);
  const [itensInativos, setItensInativos] = useState<ComponenteProjetoComQuantidade[]>([]);
  const [openModalItensInativos, setOpenModalItensInativos] = useState(false);
  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);

  const notFoundProjectAlert = useCallback((messages?: string[])=>{
    notifierStore.setNotifier({
      title: 'Atenção',
      content: messages?.length ? messages : 'Projeto não encontrado',
      onClose: () => {
        notifierStore.setOpen(false)
        history.push('/projetos/menu-projetos')
      },
      onFinishTimeout: () => {
        history.push('/projetos/menu-projetos')
      },
      timeOut: 6000,
    })
    notifierStore.setOpen(true)
  },[history])

  const routeIsValid = useCallback((tipo: ProjetoTipoType)=>{
    return true;
  },[])

  const loadCodProjeto = async()=>{
    const request: IDataRequest = {
      url: `/projetos?id=${id}`
    }
    const response = await apiNoLoading.get(request)
    if(response.statusCode !== STATUS_CODE.OK){
      const message: string[] = Array.isArray(response?.message) ? response?.message : [response?.message];
      const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some(m => m?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
      const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) || message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
      const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) || message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));

      if (mensagemVigencia) {
        notifierStore.setNotifier({
          title: "Aviso!!!",
          content: [MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO],
          timeOut: 3500,
          onFinishTimeout: () => {
            history.push('/projetos/menu-projetos')
          },
          onClose: () => {
            notifierStore.setOpen(false);
            history.push('/projetos/menu-projetos')
          }
        });
        notifierStore.setOpen(true);
      } else if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
        notifierStore.setNotifier({
          title: "Atenção!",
          content: `${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`,
          timeOut: 3500,
          onFinishTimeout: () => {
            history.push('/projetos/menu-projetos')
          },
          onClose: () => {
            notifierStore.setOpen(false);
            history.push('/projetos/menu-projetos')
          }
        });
      }
    }
  }

  const fetch = useCallback(async()=>{
    if (id && !formState?.isEdit) {
      if (!cachedComponentes?.data?.length) return;
      if (!cachedAtributos?.data?.length) return;

      const [categoriasEstruturas, categoriasAcessorios] = await Promise.all([
        componenteProvider.buscarCategoriasPorGrupo('itens_estrutura'),
        componenteProvider.buscarCategoriasPorGrupo('acessorios')
      ])

      const cachedCategoriasEstruturasIds = categoriasEstruturas.map(item => item.id)
      const cachedCategoriasAcessoriosIds = categoriasAcessorios.map(item => item.id)

      const projectResult = await verticaisManager.find<ProjetoOutput[]>({
        primaryKey: id,
        includes: ["endereco", "cidade", "solicitacao", "revisoes", "componentes", "estruturas_grupos", "ev", "analista", "distribuidor", "revenda", "uploads", "disposicoes", "grupo_estrutura", "anexos", "descontos", "componentes_modificados", "componentes.inversores_gridzero", "componentes.inversores_rsd"]
      })

      if (projectResult?.statusCode !== STATUS_CODE.OK || !projectResult?.data?.length) {
        const message: string[] = (projectResult?.message && (Array.isArray(projectResult?.message) ? projectResult?.message : [projectResult?.message])) || [];
        const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some(m => m?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
        const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) || message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
        const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) || message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));

        if (mensagemVigencia || mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
          notFoundProjectAlert(message)
        } else {
          notFoundProjectAlert()
        }
        return;
      }

      const details = projectResult?.data?.[0]
      if (!details) return;


      if (!routeIsValid(details.tipo)) {
        formState$.next(DEFAULT_PROJETO)
        history.replace("/projetos", { done: true })
        return;
      }
      const componentsIds = (details?.componentes?.filter(comp=>comp.quantidade > 0))?.map(x=>x.componente_id);
      const resultComponentes = await componenteProvider.buscarComponentesPorId(componentsIds || []);

      const componentesDoProjetoComQuantidade: ComponenteProjetoComQuantidade [] = []
      details.componentes?.forEach((savedComponente) => {
        const grupos = savedComponente.estruturas_grupos || [] 
        if (grupos.length > 0) {
          grupos.forEach(item => {
            const comp = resultComponentes?.find((cachedComponente: any) => cachedComponente.id === item.componente_id)
            if (comp) {
              if([ID_MEDIDOR, ID_TRANSFORMADOR_CORRENTE, ID_MONITORAMENTO, ID_RSD].includes(comp.categoria_componentes_id)){
                if(comp.inversores_gridzero && comp.inversores_gridzero.length > 0){
                  const listInversorGridZero: any[] = []
                  comp.inversores_gridzero.forEach((g: any) => {
                    const compInversor = resultComponentes.find((x: any)=>x.id === g.inversor_id);
                    if(compInversor) {
                      listInversorGridZero.push(compInversor);
                    }
                  })

                  if(listInversorGridZero && listInversorGridZero.length > 0){
                    componentesDoProjetoComQuantidade.push({...comp, ...item, valor_unitario: savedComponente.valor_unitario })
                  }
                }

                if (comp.inversores_rsd && comp.inversores_rsd.length > 0) {
                  const inversoresRSD = comp.inversores_rsd || [];
                  const idsInversoresProjeto = new Set(resultComponentes.map((x: any) => x.id));
                  const temInversorValido = inversoresRSD.some((g: any) => idsInversoresProjeto.has(g.inversor_id));

                  if (temInversorValido) {
                    componentesDoProjetoComQuantidade.push({
                      ...comp,
                      ...item,
                      valor_unitario: savedComponente.valor_unitario,
                    });
                  }
                }
              } else {
                componentesDoProjetoComQuantidade.push({...comp, ...item, valor_unitario: savedComponente.valor_unitario })
              }
            }
          })
        } else {
          const comp = resultComponentes?.find((cachedComponente: any) => cachedComponente.id === savedComponente.componente_id)
          if (comp) {
            
            if([ID_MEDIDOR, ID_TRANSFORMADOR_CORRENTE, ID_MONITORAMENTO, ID_RSD].includes(comp.categoria_componentes_id)){
              if(comp.inversores_gridzero && comp.inversores_gridzero.length > 0){
                const listInversorGridZero: any[] = []
                comp.inversores_gridzero.forEach((g: any) => {
                  const compInversor = resultComponentes.find((x: any)=>x.id === g.inversor_id);
                  if(compInversor) {
                    listInversorGridZero.push(compInversor);
                  }
                })

                if(listInversorGridZero && listInversorGridZero.length > 0){
                  componentesDoProjetoComQuantidade.push({...comp, ...savedComponente })
                }
              }

              if (comp.inversores_rsd && comp.inversores_rsd.length > 0) {
                const inversoresRSD = comp.inversores_rsd || [];
                const idsInversoresProjeto = new Set(resultComponentes.map((x: any) => x.id));
                const temInversorValido = inversoresRSD.some((g: any) => idsInversoresProjeto.has(g.inversor_id));
                if (temInversorValido) {
                  componentesDoProjetoComQuantidade.push({ ...comp, ...savedComponente });
                }
              }
            } else {
              componentesDoProjetoComQuantidade.push({...comp, ...savedComponente })
            }
          }
        }
      })

      const projetoHelper = new ProjetoHelper(details, { 
        estados: estados?.data || [],
        componentesDoProjetoComQuantidade,
        cachedCategoriasEstruturasIds,
        cachedCategoriasAcessoriosIds,
        cachedAtributos: cachedAtributos.data || [],
        cachedGrupoEstrutura: grupoEstrutura?.data || [],
        cachedComponentes: cachedComponentes?.data || [],
        regioes: regioes?.data || [],
        estadosServico: estadosServico?.data || [],
      })

      const payload = await projetoHelper.formatar()
      
      payload.old_componentes_edicao = componentesDoProjetoComQuantidade || []
      payload.old_estado_id = details?.estado_id;


      // validação para não permitir inversores sem gridzero ou RSD
      if(resultComponentes?.length){
        const itensInativos: any[] = resultComponentes?.filter((x: any)=>!x.considerar_calculo);
        resultComponentes.forEach((c: any) => {
          if([ID_MEDIDOR, ID_TRANSFORMADOR_CORRENTE, ID_MONITORAMENTO].includes(c.categoria_componentes_id)){
            const comp = details.componentes?.find((x: any)=>x.componente_id === c.id);
            if(comp){
              if(comp.inversores_gridzero && comp.inversores_gridzero.length > 0){
                const listInversorGridZero: any[] = []
                comp.inversores_gridzero.forEach(g => {
                  const compInversor = resultComponentes.find((x: any)=>x.id === g.inversor_id);
                  if(compInversor) {
                    listInversorGridZero.push(compInversor);
                  }
                })

                if(!(listInversorGridZero && listInversorGridZero.length > 0) && !itensInativos?.find((x: any)=>x.id === c.id)){
                  itensInativos.push(c);
                }
              } else if(!itensInativos?.find((x: any)=>x.id === c.id)){
                itensInativos.push(c);
              }
            }
          }

          if (c.categoria_componentes_id === ID_RSD) {
            const comp = details.componentes?.find((x: any) => x.componente_id === c.id);
            if (!comp) return;

            const inversoresRSD = comp.inversores_rsd || [];
            const idsInversoresProjeto = new Set(resultComponentes.map((x: any) => x.id));
            const jaInativo = itensInativos.some((x: any) => x.id === c.id);
            if (jaInativo) return;

            if (inversoresRSD.length === 0) {
              itensInativos.push(c);
              return;
            }

            const temInversorValido = inversoresRSD.some((g: any) => idsInversoresProjeto.has(g.inversor_id));
            if (!temInversorValido) {
              itensInativos.push(c);
            }
          }
        })

        if(itensInativos?.length){
          setItensInativos(itensInativos)
          setOpenModalItensInativos(true)
        }
        if(payload?.modulosList?.length){
          for await(const modulo of payload.modulosList){
            if (modulo.selecionado && itensInativos?.find((x: any)=>x.id === modulo.componente_id)){
              modulo.selecionado = false
            }
          }
        }
      }

      //limpa termo aceito
      payload.termo_aceito = false;
      payload.dados_termo = undefined;

      formState$.next({
        ...payload,
        clonar_projeto: clonarProjeto
      })
    }
  },[clonarProjeto, id, formState?.isEdit, cachedComponentes?.data, cachedAtributos?.data, routeIsValid, estados?.data, grupoEstrutura?.data, regioes?.data, estadosServico?.data, notFoundProjectAlert, history])

  useEffect(()=>{
    init().then(() => {
      loadCodProjeto()
      fetch()
    })
  },[cachedComponentes, cachedAtributos])  
  
  useEffect(()=>{
    if (!checkSegmentoConta && formState?.id) {
      verificarSegmentoConta({ 
        goBack: true,
        segmento: formState?.segmento ||'on', 
        revendaId: formState?.revenda_id || formState?.revenda?.id || undefined, 
        distribuidorId: formState?.distribuidor_id || formState?.distribuidor?.id || undefined
      });
      setCheckSegmentoConto(true);
    }
  },[formState, checkSegmentoConta]);

  if (!formState?.id || regioes?.data?.length === 0) {
    return null;
  }

  return (
    <>
      <ModalInfoInativos
      open={openModalItensInativos && itensInativos.length > 0}
      onClose={()=>setOpenModalItensInativos(false)}
      itensInativos={itensInativos} />
      {children}
    </>
  )
}

